export const sizes = {
  none: '0',
  auto: 'auto',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '40px',
  initial: 'initial',
  mabpoxSpace: '14px',
};

export const viewSizes = {
  xs: '20vw',
  sm: '30vw',
  md: '40vw',
  lg: '60vw',
  xl: '80vw',
};
